import React, { useContext } from 'react';
import classnames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDefaultBidDescriptionStyles } from './styles/default-bid-description-style';
import { useCurrencyCode, useDefaultBid } from '../utils';

export const DefaultBidDescription = () => {
  const classes = useDefaultStyles(getDefaultBidDescriptionStyles);
  const i18n = useContext(I18nContext);
  const currency = useCurrencyCode();
  const defaultBid = useDefaultBid();

  return (
    <div className={classnames(classes.root, 'list-footer')}>{i18n.getString(_TL_('The default ad group bid is {{amount}} {{currency}}'), {
      amount: defaultBid,
      currency,
    })}
    </div>
  );
};
